import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Synergy from '../views/Synergy.vue'
import Services from '../views/Services.vue'
import Research from '../views/Research.vue'
import TechnologyPage from '../views/Technology.vue'
import TechnologyDetails from '../views/TechnologyDetails.vue' // Import TechnologyDetails.vue
import AIML from '../views/AIML.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
// Home-specific pages
import HomeResearch from '../views/HomeResearch.vue'
import HomeContactUs from '../views/HomeContactUs.vue'
import HomeAbout from '../views/HomeAbout.vue'
import HomeServices from '../views/HomeServices.vue'
import HomeSynergy from '../views/HomeSynergy.vue'
import WhySogdo from '../views/WhySogdo.vue'
import Careers from '../views/Careers.vue'
import FAQ from '../views/FAQ.vue'
// Legal pages
import Terms from '../views/Terms.vue'
import Privacy from '../views/Privacy.vue'
import RefundPolicy from '../views/RefundPolicy.vue'
import PaymentPolicy from '../views/PaymentPolicy.vue'
// Service pages
import NormalCarServices from '../views/services/NormalCarServices.vue'
import AutoServices from '../views/services/AutoServices.vue'
import ChamparanEliteTouch from '../views/services/ChamparanEliteTouch.vue'
import ElectricBikeServices from '../views/services/ElectricBikeServices.vue'
import ElectricCarServices from '../views/services/ElectricCarServices.vue'
import NormalBikeServices from '../views/services/NormalBikeServices.vue'
import Presence from '../views/Presence.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Sogdo - Innovation, AI & Growth' },
  },
  {
    path: '/synergy',
    name: 'Synergy',
    component: Synergy
  },
  {
    path: '/home-synergy',
    name: 'HomeSynergy',
    component: HomeSynergy,
    meta: { title: 'Synergy & Products || Sogdo' }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: { title: 'Services || Sogdo' }
  },
  {
    path: '/home-services',
    name: 'HomeServices',
    component: HomeServices,
    meta: { title: 'Services || Sogdo' }
  },
  {
    path: '/research',
    name: 'Research',
    component: Research,
    meta: { title: 'Research & Development || Sogdo' }
  },
  {
    path: '/home-research',
    name: 'HomeResearch',
    component: HomeResearch,
    meta: { title: 'Research & Development || Sogdo' }
  },
  {
    path: '/sogdotech',
    name: 'TechnologyPage',
    component: TechnologyPage, // Use the alias
    meta: { title: 'Technology || Sogdo' },
  }
  ,
  {
    path: '/sogdotech/:id', // Dynamic route for technology details
    name: 'TechnologyDetails',
    component: TechnologyDetails,
    meta: { title: 'Technology Details || Sogdo' },
    props: true // Enables passing route params as props
  },
  {
    path: '/ai-ml',
    name: 'AI & ML',
    component: AIML,
    meta: { title: 'AI & ML || Sogdo' },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: 'About Us || Sogdo' },
  },
  {
    path: '/home-about',
    name: 'HomeAbout',
    component: HomeAbout,
    meta: { title: 'About Us || Sogdo' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: { title: 'Contact Us || Sogdo' },
  },
  {
    path: '/home-contact',
    name: 'HomeContactUs',
    component: HomeContactUs,
    meta: { title: 'Contact Us || Sogdo' },
  },
  {
    path: '/why-sogdo',
    name: 'WhySogdo',
    component: WhySogdo,
    meta: { title: 'Why Choose Sogdo || Sogdo' },
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers
  },
  {
    path: '/faqs',
    name: 'FAQ',
    component: FAQ
  },
  // Legal pages
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: { title: 'Terms of Service || Sogdo' }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { title: 'Privacy Policy || Sogdo' }
  },
  {
    path: '/refund-policy',
    name: 'RefundPolicy',
    component: RefundPolicy,
    meta: { title: 'Refund Policy || Sogdo' }
  },
  {
    path: '/payment-policy',
    name: 'PaymentPolicy',
    component: PaymentPolicy,
    meta: { title: 'Payment Policy || Sogdo' }
  },
  // Service routes
  {
    path: '/services/normal-car',
    name: 'NormalCarServices',
    component: NormalCarServices,
    meta: { title: 'Normal Car Services || Sogdo' }
  },
  {
    path: '/services/electric-car',
    name: 'ElectricCarServices',
    component: ElectricCarServices,
    meta: { title: 'Electric Car Services || Sogdo' }
  },
  {
    path: '/services/normal-bike',
    name: 'NormalBikeServices',
    component: NormalBikeServices,
    meta: { title: 'Normal Bike Services || Sogdo' }
  },
  {
    path: '/services/electric-bike',
    name: 'ElectricBikeServices',
    component: ElectricBikeServices,
    meta: { title: 'Electric Bike Services || Sogdo' }
  },
  {
    path: '/services/auto',
    name: 'AutoServices',
    component: AutoServices,
    meta: { title: 'Auto Services || Sogdo' }
  },
  {
    path: '/services/champaran-elite',
    name: 'ChamparanEliteTouch',
    component: ChamparanEliteTouch,
    meta: { title: 'Champaran Elite Touch || Sogdo' }
  },
  {
    path: '/presence',
    name: 'Presence',
    component: Presence,
    meta: { title: 'Our Presence || Sogdo' }
  },
  // Catch-all route for 404 pages
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'Page Not Found || Sogdo' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // Always scroll to top when changing routes
    return { top: 0 }
  }
})

export default router
